import { Controller } from "@hotwired/stimulus";
import { application } from "src";
import { isBlank, toMilliseconds } from "@fretadao/f-js-utils";

// @example:
// <div data-controller="auto-focus-next-field">
//   <input data-auto-focus-next-field-target="field" type="text" maxlength="1">
//   <input data-auto-focus-next-field-target="field" type="text" maxlength="1">
//   <input type="submit" data-auto-focus-next-field-target="field">
// </div>
application.register("auto-focus-next-field", class extends Controller {
  static get targets() {
    return ['field'];
  }

  connect() {
    document.addEventListener('load', this.#focusFirstEmptyInput);

    this.element.addEventListener('paste', (event) => {
      const data = event.clipboardData.getData('text').trim();

      this.fieldTargets.forEach((field, index) => {
        field.value = data.slice(index, index + field.maxLength);
      });

      this.#focusFirstEmptyInput();
    });

    this.fieldTargets.forEach((field, index) => {
      const isDeletingCharacter = (keyCode) => ['Backspace', 'Delete'].includes(keyCode);
      const isAlreadyFilled = (field) => field.value.length === field.maxLength;

      field.addEventListener('keyup', (event) => {
        if (isDeletingCharacter(event.key) && isBlank(field.value)) return this.fieldTargets[index - 1]?.focus();
        if (isAlreadyFilled(field)) this.fieldTargets[index + 1]?.focus();
      });
    });
  }

  #focusFirstEmptyInput() {
    setTimeout(
      () => {
        const nextField = this.#findNextEmptyField();

        if (!nextField) return;

        nextField.type === 'submit' ? nextField.click() : nextField.focus();
      },
      toMilliseconds(0.1, 'seconds')
    );
  }

  #findNextEmptyField() {
    return this.fieldTargets.find((field) => isBlank(field.value));
  }
});
